import React from "react";
import "./Main.css";
import { t } from "i18next";
import Osipov from "../../assets/osipov.png";
import Titarenko from "../../assets/Titarenko.jpg";
import Vladislav from "../../assets/Vladislav.jpg";
import Ruslan from "../../assets/ruslan.jpg";
import Evgen from "../../assets/Evgen.jpg";
import Sergiy from "../../assets/sergiy.jpg";

export default function OurTeam() {
  const team = [
    {
      image: Vladislav,
      name: t("vladislav"),
      position: "Засновник/голова",
    },
    {
      image: Ruslan,
      name: t("ruslan"),
      position: "Керівник проєктів",
    },
    {
      image: Evgen,
      name: t("evgen"),
      position: "Керівник проєктів",
    },
    {
      image: Titarenko,
      name: t("titarenko"),
      position: "Керівник проєктів",
    },
    {
      image: Osipov,
      name: t("yaroslav"),
      position: "Керівник проєктів",
    },
    {
      image: Sergiy,
      name: t("sergiy"),
      position: "Керівник проєктів",
    },
  ];

  return (
    <section className="skyua-main-section skyua-main-section--soft">
      <div className="skyua-main-container">
        <div className="skyua-main-heading">
          <span className="skyua-main-eyebrow">{t("our team title")}</span>
          <h2>
            {t("home team heading") !== "home team heading"
              ? t("home team heading")
              : "Люди, які відповідають за реалізацію допомоги"}
          </h2>
        </div>

        <div className="skyua-team-grid">
          {team.map((person) => (
            <article className="skyua-team-card" key={person.name}>
              <div className="skyua-team-card__photo">
                <img src={person.image} alt={person.name} />
              </div>

              <div className="skyua-team-card__copy">
                <h3>{person.name}</h3>
                <p>{person.position}</p>
                <span>КОМАНДА ФОНДУ</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
